import { useEffect, useState } from "react"
import { useTheme } from "@/components/theme-provider"
import { useIsMobile } from "@/hooks/use-mobile"
import { Toaster as Sonner, toast } from "sonner"
import { visibilityManager } from "@/utils/visibilityManager"

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  const { resolvedTheme } = useTheme()
  const isMobile = useIsMobile()
  const [isVisible, setIsVisible] = useState(true)
  const isSafari = visibilityManager.isSafariBrowser()

  // Safari: Dim instead of unmounting to prevent portal issues
  // Uses centralized visibility manager for consistent debouncing
  useEffect(() => {
    if (!isSafari) return;
    
    return visibilityManager.subscribe((visible) => {
      setIsVisible(visible);
    }, 'Sonner/Toaster');
  }, [isSafari]);

  return (
    <Sonner
      theme={resolvedTheme as ToasterProps["theme"]}
      closeButton
      className={isMobile ? "toast-mobile" : "toast-desktop"}
      style={{ 
        zIndex: 9999,
        // Safari: Reduce opacity and block interaction, but don't unmount
        ...(isSafari && !isVisible ? {
          opacity: 0.3,
          pointerEvents: 'none' as const
        } : {})
      }}
      {...props}
    />
  )
}

export { Toaster, toast }
